import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../lib/shared/validators";

export const creditNoteStatus = v.union(
  v.literal("draft"),
  v.literal("issued"),
  v.literal("voided"),
);

export const creditNoteReason = v.union(
  v.literal("return"),
  v.literal("discount"),
  v.literal("correction"),
  v.literal("cancellation"),
  v.literal("other"),
);

const creditNoteItem = v.object({
  itemId: v.string(),
  description: v.string(),
  quantity: v.number(),
  unitPrice: v.number(),
  total: v.number(),
  // Impuesto por-ítem heredado del ítem de la factura (o elegido en libres).
  taxRate: v.optional(v.number()),
  exemptAmount: v.optional(v.number()),
});

export const validatorCreditNote = v.object({
  // Opcionales para soportar el borrador inicial (draft-autosave, espejo de invoices).
  // Se asignan al elegir factura y motivo; obligatorios al emitir.
  invoiceId: v.optional(v.id("invoices")),
  clientId: v.optional(v.id("clients")),
  // code: nomenclatura interna (NC-2025-0001). correlative: número fiscal SAR (06).
  // Opcionales para retrocompatibilidad con notas existentes.
  code: v.optional(v.string()),
  correlative: v.optional(v.string()),
  status: creditNoteStatus,
  originalAmount: v.number(),
  creditAmount: v.number(),
  taxAmount: v.optional(v.number()),
  reason: v.optional(creditNoteReason),
  items: v.array(creditNoteItem),
  issueDate: v.number(),
  printingAuthorizationCode: v.optional(v.string()),
  notes: v.optional(v.string()),
  voidReason: v.optional(v.string()),
  voidDate: v.optional(v.number()),
  internalControl,
});

export const credit_notes = defineTable(validatorCreditNote)
  .index("by_company_id", ["internalControl.companyId"])
  .index("by_company_and_branch", ["internalControl.companyId", "internalControl.branchId"])
  .index("by_invoice_id", ["invoiceId"])
  .index("by_client_id", ["clientId"])
  .index("by_status", ["status"])
  .index("by_company_and_status", ["internalControl.companyId", "status"])
  .index("by_correlative", ["correlative"])
  .index("by_company_and_code", ["internalControl.companyId", "code"])
  .index("by_branch_id", ["internalControl.branchId"])
  .index("by_state", ["internalControl.state"])
  .index("by_created_at", ["internalControl.createdAt"]);
